import { Form, useForm } from '@/components/forms';
import { Label } from '@/design-system/label';
import { Switch } from '@/design-system/switch';
import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { z } from 'zod';

const addTagFormSchema = z.object({
  rank: z.boolean(),
  category: z.boolean(),
  excellentStore: z.boolean(),
  largeStore: z.boolean(),
  privateRentalAvailable: z.boolean(),
  isThereManyEnrolledPeople: z.boolean(),
  isVipRoomAvaible: z.boolean(),
  isSuitableForGirl: z.boolean(),
});

const AddTagManagementForm = ({ clubId }: { clubId: string }) => {
  const { mutate: createTagManagement } = useMutation('createTagManagement');

  const form = useForm({ schema: addTagFormSchema, mode: 'onBlur' });

  return (
    <Form
      form={form}
      onSubmit={() => {
        createTagManagement({
          clubId: clubId || '',
          locationTag: true,
          locationValue: '  string',
          rankTag: true,
          rankValue: 'string',
          categoryTag: true,
          categoryTagValue: 'string',
          excelentStoreTag: 'string',
          largeStoreTag: 'string',
          largeStoreValue: 'string',
          privateRentalAvailable: true,
          isThereManyEnrolledPeople: true,
          isVipRoomAvaible: true,
          isSuitableForGirl: true,
        });
      }}
    >
      <div className="w-full flex flex-col gap-4.5">
        <div className="flex items-center gap-3">
          <Label>Tags</Label>
          <hr className="h-0.5 w-full text-border-subtle" />
        </div>
        {/* <Input label="storeManagement.hostManagement.form.addGallery.title" {...form.register('rank')} /> */}
        <div className="flex gap-3 items-center">
          <Switch {...form.register('rank')} />
          <Label>Rank</Label>
        </div>
        <div className="flex gap-3 items-center">
          <Switch {...form.register('category')} />
          <Label>Category</Label>
        </div>

        <div className="flex gap-3 items-center">
          <Switch {...form.register('excellentStore')} />
          <Label>Excellent Store</Label>
        </div>

        <div className="flex gap-3 items-center">
          <Switch {...form.register('largeStore')} />
          <Label>Large Store</Label>
        </div>

        <div className="flex items-center gap-3">
          <Label>Availability</Label>
          <hr className="h-0.5 w-full text-border-subtle" />
        </div>
        <div className="flex gap-3 items-center">
          <Switch {...form.register('privateRentalAvailable')} />
          <Label>Private Rental Available</Label>
        </div>

        <div className="flex gap-3 items-center">
          <Switch {...form.register('isThereManyEnrolledPeople')} />
          <Label>Many Enrolled People</Label>
        </div>

        <div className="flex gap-3 items-center">
          <Switch {...form.register('isVipRoomAvaible')} />
          <Label>VIP Room Available</Label>
        </div>

        <div className="flex gap-3 items-center">
          <Switch {...form.register('isSuitableForGirl')} />
          <Label>Suitable for Girl</Label>
        </div>
      </div>
    </Form>
  );
};

export default AddTagManagementForm;
